export const recipes = [
  {
    id: 1,
    name: "Classic Cheeseburger",
    type: "American",
    image:
      "https://images.pexels.com/photos/2119758/pexels-photo-2119758.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    ingredients: [
      "1 lb ground beef",
      "1 onion, chopped",
      "2 cloves of garlic, minced",
      "1 cup of diced tomatoes",
      "1 cup of shredded cheese",
      "Salt and pepper to taste",
    ],
    instructions: [
      "In a skillet, cook the ground beef until browned.",
      "Add the chopped onions and minced garlic. Cook until onions are translucent.",
      "Add the diced tomatoes and season with salt and pepper. Simmer for 10 minutes.",
      "Sprinkle the shredded cheese over the mixture and cover the skillet. Let the cheese melt.",
      "Serve hot and enjoy!",
    ],
  },
  {
    id: 2,
    name: "Spaghetti Aglio e Olio",
    type: "Italian",
    image:
      "https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    ingredients: [
      "8 oz spaghetti",
      "2 cloves of garlic, minced",
      "1/4 cup of olive oil",
      "1/4 cup of grated Parmesan cheese",
      "1/4 cup of chopped fresh basil",
      "Salt and pepper to taste",
    ],
    instructions: [
      "Cook the spaghetti according to package instructions. Drain and set aside.",
      "In a pan, heat the olive oil over medium heat.",
      "Add the minced garlic and sauté until fragrant.",
      "Add the cooked spaghetti to the pan and toss to coat with the garlic-infused oil.",
      "Season with salt and pepper. Sprinkle grated Parmesan cheese and chopped fresh basil.",
      "Toss again to combine all the ingredients.",
      "Serve hot with an extra sprinkle of Parmesan cheese and basil on top.",
    ],
  },
  {
    id: 3,
    name: "Sweet and Sour Chicken",
    type: "Chinese",
    image:
      "https://images.pexels.com/photos/3386854/pexels-photo-3386854.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    ingredients: [
      "1 lb boneless chicken thighs, cut into small pieces",
      "2 cups of cooked rice",
      "1 cup of mixed vegetables",
      "2 cloves of garlic, minced",
      "2 tbsp of soy sauce",
      "1 tbsp of oyster sauce",
      "1 tbsp of sesame oil",
      "Salt and pepper to taste",
    ],
    instructions: [
      "In a wok or large skillet, heat the sesame oil over high heat.",
      "Add the minced garlic and stir-fry for a few seconds.",
      "Add the chicken pieces and cook until browned and cooked through.",
      "Add the mixed vegetables and stir-fry for a few minutes until they are tender-crisp.",
      "In a small bowl, mix together the soy sauce and oyster sauce. Pour the sauce over the chicken and vegetables.",
      "Season with salt and pepper to taste. Stir well to combine.",
      "Add the cooked rice to the wok and stir-fry until everything is heated through.",
      "Serve hot and enjoy this delicious Chinese-style fried rice!",
    ],
  },
  {
    id: 4,
    name: "Butter Chicken",
    type: "Indian",
    image: "https://example.com/indian.jpg",
    ingredients: [
      "1 cup of basmati rice",
      "1 onion, finely chopped",
      "2 cloves of garlic, minced",
      "1 inch piece of ginger, grated",
      "1 tsp of turmeric powder",
      "1 tsp of cumin powder",
      "1 tsp of coriander powder",
      "1 cup of mixed vegetables (carrots, peas, bell peppers)",
      "2 cups of water",
      "Salt to taste",
    ],
    instructions: [
      "Rinse the basmati rice thoroughly and soak it in water for 30 minutes. Drain and set aside.",
      "In a large pan, heat the cooking oil over medium heat.",
      "Add the chopped onion and sauté until golden brown.",
      "Add the minced garlic and grated ginger. Sauté for a minute until fragrant.",
      "Add the turmeric powder, cumin powder, and coriander powder. Mix well.",
      "Add the mixed vegetables and cook for a few minutes until they start to soften.",
      "Add the soaked and drained basmati rice to the pan. Stir gently to coat the rice with the spices.",
      "Add water (1.5 cups of water for 1 cup of rice) and season with salt.",
      "Cover the pan and cook on low heat for about 15-20 minutes until the rice is cooked and the water is absorbed.",
      "Fluff the rice with a fork and serve hot with your favorite Indian curry or side dish.",
    ],
  },
];
